import React, { useEffect, useState } from "react";
import { Modal, Table, Card, ListGroup, Form, Row, Col, Button, Badge } from "react-bootstrap";
import axios from "axios";
import useToken from "../../components/utils/token";
import Base from "../../components/BaseTemplate";
import RxnTable from "../../components/RxnTable";
import Select, { components } from "react-select";
import { IconDelete } from "../../components/SVGs";
import { toast, Toaster } from "react-hot-toast";

export default function UserMyReactions() {
    const [rxnList, setRxnList] = useState({
        columns: [
            {
                label: "ID",
                field: "rxnId",
            },
            {
                label: "Reaction Name",
                field: "rxnName",
            },
            {
                label: "Current State",
                field: "currentState",
            },
            {
                label: "Admin Comment",
                field: "adminComment"
            },
            {
                label: "Last Updated",
                field: "lastUpdated",
            },
        ],
        data: [],
    });

    const [rxnDetail, setRxnDetail] = useState(
        {
            currentState: "",
            dateSubmitted: "",
            email: "",
            lastUpdated: "",
            rxnDescription: "",
            rxnId: "",
            rxnName: "",
            rxnSmarts: "",
            rxnSmartsDescription: "",
            rxnTags: [],
            status: "",
        }
    )

    const [syn, setSyn] = useState([]);
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [showDelete, setShowDelete] = useState(false);

    //
    // Axios/API Calls
    //
    async function getUserRxnList() {
        setLoading(true);
        await axios({
            method: "GET",
            url: "/my_reactions",
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
        }).then((res) => {
            setRxnList({ ...rxnList, data: res.data })
        })
        setLoading(false);

    }

    async function getUserRxnDetail(id) {
        await axios({
            method: "GET",
            url: `/my_reactions/${id}`,
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
        }).then((res) => {
            setRxnDetail({
                currentState: res.data.currentState,
                dateSubmitted: res.data.dateSubmitted,
                email: res.data.email,
                lastUpdated: res.data.lastUpdated,
                rxnDescription: res.data.rxnDescription,
                rxnId: res.data.rxnId,
                rxnName: res.data.rxnName,
                rxnSmarts: res.data.rxnSmarts,
                rxnSmartsDescription: res.data.rxnSmartsDescription,
                rxnTags: res.data.rxnTags,
                status: res.data.status,
                adminComment: res.data.adminComment?.split('\n'),
            })

            let data = res.data.synthons;
            let newSyn = [];

            for (let index = 0; index < data.length; index++) {
                newSyn.push({
                    synthon_name: res.data.synthons[index].synName,
                    synthon_inclusion_smarts: res.data.synthons[index].inSmarts
                        ? res.data.synthons[index].inSmarts.join("\n")
                        : "",
                    synthon_exclusion_smarts: res.data.synthons[index].exSmarts
                        ? res.data.synthons[index].exSmarts.join("\n")
                        : "",
                });
            }
            setSyn(newSyn);
        })
    }

    async function getTags() {
        await axios({
            method: "GET",
            url: "/reactionClass/tagList",
        }).then((res) => {
            setTags(res.data.tags)
        }).catch((err) => {
            console.tag(err)
        });
    }

    async function submitUserRxnUpdate() {
        let rxnData = {
            ...rxnDetail,
            synthons: syn.map((synthon) => {
                return {
                    ...synthon,
                    exSmarts: synthon.synthon_exclusion_smarts.split("\n"),
                    inSmarts: synthon.synthon_inclusion_smarts.split("\n"),
                };
            }),
        };

        await axios({
            method: "POST",
            url: `/my_reactions/${rxnDetail.rxnId}/update`,
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
            data: rxnData,
        }).then((res) => {
            getUserRxnList();
            toast.success(res.data.msg);
            handleCloseEdit();
        }).catch((err) => {
            console.log(err)
        })
    }

    async function submitDelete() {
        await axios({
            method: "POST",
            url: `/my_reactions/${rxnDetail.rxnId}/withdraw`,
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
        }).then((res) => {
            getUserRxnList();
            toast.success(res.data.msg);
            handleCloseDelete();
        }).catch((err) => {
            console.log(err);
        })
    }

    async function submitPublish() {
        await axios({
            method: "POST",
            url: `/my_reactions/${rxnDetail.rxnId}/publish`,
            headers: {
                "Authorization": `Bearer ${localStorage.getItem("token")}`,
            },
        }).then((res) => {
            getUserRxnList();
            toast.success(res.data.msg);
            handleCloseDelete();
        }).catch((err) => {
            console.log(err);
        })
    }

    //
    // Modal Handlers
    //
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = (row) => {
        getUserRxnDetail(row.rxnId);
        setShowEdit(true);
    };

    const handleCloseDelete = () => {
        setRxnDetail({
            currentState: "",
            dateSubmitted: "",
            email: "",
            lastUpdated: "",
            rxnDescription: "",
            rxnId: "",
            rxnName: "",
            rxnSmarts: "",
            rxnSmartsDescription: "",
            rxnTags: [],
            status: "",
        })

        setShowDelete(false);
    };
    const handleShowDelete = (row) => {
        setRxnDetail({
            rxnId: row.rxnId,
            rxnName: row.rxnName,
        });
        setShowDelete(true);
    };

    //
    // Helper Functions
    //

    // Triggers every change in synthon form
    const synFormChange = (index, e) => {
        let data = [...syn];
        data[index][e.target.id] = e.target.value;
        setSyn(data);
    };

    const handlePublish = () => {
        toast((t) => (
            <span>
                Custom and <b>bold</b>
                <button onClick={() => toast.dismiss(t.id)}>
                    Dismiss
                </button>
            </span>
        ))
    }

    useEffect(() => {
        getUserRxnList();
        getTags();
    }, [])


    //
    //HTML
    //
    return (
        <Base>
            <Toaster />
            <RxnTable
                striped
                bordered
                hover
                data={rxnList}
                loading={loading}
                actions={{
                    edit: true,
                    editLogic: (row) => {
                        handleShowEdit(row);
                    },
                    delete: true,
                    deleteLogic: (row) => {
                        handleShowDelete(row);
                    },
                }}
            />

            <Modal
                size="xl"
                backdrop="static"
                show={showEdit}
                onHide={handleCloseEdit}
            >
                <Modal.Header closeButton>
                    <Modal.Title as="h2">
                        Reaction Detail
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="text-center mb-4">
                        <div className="alert alert-light d-inline-block shadow border-2" style={{ borderColor: '#dee2e6' }}>
                            <div className="mb-2">
                                <Badge bg="secondary" className="fs-6 px-3 py-2">
                                    <i className="fas fa-info-circle me-1"></i>
                                    ADMIN COMMENT
                                </Badge>
                            </div>
                            <div className="fs-4 fw-bold text-dark">
                                {rxnDetail.adminComment?.map((value, index) => (
                                    <div key={`adminComment${index}`}>{value}</div>
                                ))}
                            </div>
                        </div>
                    </div>


                    {/*  */}
                    {/*  */}
                    {/* Reaction Form */}
                    {/*  */}
                    {/*  */}
                    <Form>
                        <Card>
                            <Card.Header>
                                <Card.Title as="h3">Reaction</Card.Title>
                            </Card.Header>
                            <Card.Body>
                                <Form.Group controlId="rxnName">
                                    <Form.Label>Reaction Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter reaction name"
                                        value={rxnDetail.rxnName}
                                        onChange={(e) =>
                                            setRxnDetail({
                                                ...rxnDetail,
                                                rxnName: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                                <Form.Group controlId="rxnDescription">
                                    <Form.Label>Reaction Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Enter reaction description"
                                        value={rxnDetail.rxnDescription}
                                        onChange={(e) =>
                                            setRxnDetail({
                                                ...rxnDetail,
                                                rxnDescription: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                                <Form.Group controlId="rxnSmarts">
                                    <Form.Label>Reaction SMARTS</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Enter reaction SMARTS"
                                        value={rxnDetail.rxnSmarts}
                                        onChange={(e) =>
                                            setRxnDetail({
                                                ...rxnDetail,
                                                rxnSmarts: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                                <Form.Group controlId="rxnSmartsDescription">
                                    <Form.Label>Reaction SMARTS Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Enter reaction SMARTS description"
                                        value={rxnDetail.rxnSmartsDescription}
                                        onChange={(e) =>
                                            setRxnDetail({
                                                ...rxnDetail,
                                                rxnSmartsDescription: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                                <Form.Group controlId="rxnTags">
                                    <Form.Label>Add Reaction Tag</Form.Label>
                                    <Select
                                        value={rxnDetail.rxnTags}
                                        options={tags}
                                        isMulti
                                        isSearchable
                                        className="mb-3"
                                        placeholder="Select Tag"
                                        onChange={(e) => {
                                            setRxnDetail({
                                                ...rxnDetail,
                                                rxnTags: e,
                                            });
                                        }}
                                    />
                                </Form.Group>
                            </Card.Body>
                        </Card>
                        <br />

                        {/*  */}
                        {/*  */}
                        {/* Synthon Form */}
                        {/*  */}
                        {/*  */}
                        {syn.length >= 1 &&
                            syn.map((input, index) => (
                                <div key={`synthon${index}`}>
                                    <Card >
                                        <Card.Header>
                                            <Row>
                                                <Col className="leftText">
                                                    <h3>Synthon {index + 1}</h3>
                                                </Col>
                                                <Col></Col>
                                                <Col className="rightText">
                                                    {syn.length > 1 && (
                                                        <Button
                                                            key={`deleteSyn${index}`}
                                                            className=" m-1"
                                                            variant="outline-danger"
                                                            onClick={() => {
                                                                let tempSynArr = [...syn];
                                                                tempSynArr.splice(index, 1);
                                                                setSyn(tempSynArr);
                                                            }}
                                                        >
                                                            <IconDelete />
                                                        </Button>
                                                    )}
                                                </Col>
                                            </Row>
                                        </Card.Header>
                                        <Card.Body>
                                            <Form.Group className="mb-3" controlId={"synthon_name"}>
                                                <Form.Label>Synthon Name</Form.Label>
                                                <Form.Control
                                                    value={syn[index].synthon_name}
                                                    onChange={(e) => synFormChange(index, e)}
                                                ></Form.Control>
                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId={"synthon_inclusion_smarts"}
                                            >
                                                <Form.Label>Inclusion SMARTS</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    value={syn[index].synthon_inclusion_smarts}
                                                    onChange={(e) => synFormChange(index, e)}
                                                ></Form.Control>
                                            </Form.Group>
                                            <Form.Group
                                                className="mb-3"
                                                controlId={"synthon_exclusion_smarts"}
                                            >
                                                <Form.Label>Exclusion SMARTS</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={5}
                                                    value={syn[index].synthon_exclusion_smarts}
                                                    onChange={(e) => synFormChange(index, e)}
                                                ></Form.Control>
                                            </Form.Group>
                                        </Card.Body>
                                    </Card>
                                    <br />
                                </div>
                            ))}
                    </Form>
                    <div className="centerText">
                        <Button
                            onClick={() => {
                                setSyn([
                                    ...syn,
                                    {
                                        synthon_name: "",
                                        synthon_inclusion_smarts: [],
                                        synthon_exclusion_smarts: [],
                                    },
                                ]);
                            }}
                        >
                            Add New Synthon
                        </Button>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {rxnDetail.currentState === "Approved" ?
                        <Col>
                            <Button variant="primary" type="submit" onClick={handlePublish}>
                                Publish
                            </Button>
                        </Col>
                        : null}
                    <Col className="rightText">
                        <Button variant="primary" type="submit" onClick={submitUserRxnUpdate}>
                            Submit Edit
                        </Button>
                    </Col>

                </Modal.Footer>
            </Modal>



            <Modal
                size="xl"
                backdrop="static"
                show={showDelete}
                onHide={handleCloseDelete}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Reaction</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>
                        Are you sure you want to delete <b>{rxnDetail.rxnName}</b>?
                    </h4>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        disabled={loading}
                        variant="danger"
                        type="submit"
                        onClick={() => submitDelete()}
                    >
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </Base >
    )
}